import { React, useEffect, useState } from 'react';
import axiosClient from '../../../axios-client';
import logo from '../../assets/svg/logo_front.svg';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useStateContext } from '../../context/ContextProvider.jsx';

const Footer = () => {
  
  const [loading, setLoading] = useState();
  const [ links, setLinks ] = useState();
  

  const { token } = useStateContext();
  const [lastScrollY, setLastScrollY] = useState(window.scrollY); 

  const logIn = () => {
        token ? window.location.href = '/new-message' : window.location.href = '/login'
  };
  
  const logOut = () => {
    if (token) {
      localStorage.clear();
      window.location.reload()
    } else {
      window.location.href = '/signup'
    }
  };


    useEffect(() => {
        if (!links) {
            fetchData()
        }
    }, [links]);

    const fetchData = () => {
        axiosClient.get('/pages')
            .then(({ data }) => {
                setLinks(data.data)
            })
            .catch(err => {
                const response = err.response.data;
                if (response) {
                    const errorMessages = Object.values(response)
                        .map((errorArray) => errorArray[0]);
                    setMsgError(errorMessages);
                    setErrors(response);
                } else {
                    console.error('Unexpected error response format:', response);
                }
            })
    }
  
    const socialLinks = [
      {
        href: "https://www.linkedin.com",
        iconClass: "il:linkedin",
        label: "LinkedIn",
      },
      {
        href: "https://www.youtube.com",
        iconClass: "il:youtube",
        label: "Youtube",
      },
      {
        href: "https://www.facebook.com",
        iconClass: "ri:facebook-fill",
        label: "Facebook",
      },
      {
        href: "https://www.instagram.com",
        iconClass: "il:instagram",
        label: "Instagram",
      },
    ];
  
  return (
    <>
      <div className='bg-gradient-to-br from-gray-800 to-gray-700 text-white py-3'>
        <div className='container mx-auto flex flex-col md:flex-row items-center justify-between'>
          {/* Left: Logo */}
          <div className='flex justify-center md:justify-start mb-2 md:mb-0'>
            <img src={logo} alt='Logo' className='h-8 max-w-[150px]' />
          </div>
          <div className="max-sm:block hidden text-center mt-6">
            <h1 className='text-[#B4BCC8] font-semibold text-lg mb-6 mt-[72px]'>How we are ?</h1>
            <p className='text-white text-base font-light'><span className='text-[#DF8450] font-bold'>1Confirmed</span> is your go-to solution for seamless communication, offering an integrated WhatsApp Business Platform that enables businesses to send broadcast campaigns directly to their contacts. Our platform elevates your marketing efforts by making it easy to share updates, promotions, and other announcements efficiently.</p>
            <div className='my-8'>
            <div className="justify-center py-7 flex items-center space-x-3">
              <button onClick={logIn} className="bg-[#DF8450] text-white hover:bg-[#c96d3b] transition-colors duration-300 rounded-full ps-1 pe-6 py-1 flex items-center space-x-2">
                { token ? <>
                  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.5" width="37" height="37" rx="18.5" fill="white" stroke="#F0AB83"/>
                  <g opacity="0.3">
                  <path d="M19.0002 20.4C20.0346 20.4 21.0265 19.9891 21.7579 19.2577C22.4893 18.5263 22.9002 17.5343 22.9002 16.5C22.9002 15.4656 22.4893 14.4737 21.7579 13.7423C21.0265 13.0109 20.0346 12.6 19.0002 12.6C17.9659 12.6 16.9739 13.0109 16.2425 13.7423C15.5111 14.4737 15.1002 15.4656 15.1002 16.5C15.1002 17.5343 15.5111 18.5263 16.2425 19.2577C16.9739 19.9891 17.9659 20.4 19.0002 20.4ZM10.5047 28.8409C10.384 29.1634 10.3707 29.5163 10.4667 29.8471C10.5628 30.1778 10.763 30.4687 11.0377 30.6765C13.3144 32.4458 16.1168 33.4043 19.0002 33.4C22.0032 33.4 24.7696 32.3808 26.9705 30.67C27.5295 30.2371 27.7557 29.4961 27.5009 28.837C26.8408 27.1184 25.6751 25.6404 24.1577 24.598C22.6403 23.5556 20.8424 22.9977 19.0015 22.9982C17.1605 22.9986 15.3629 23.5572 13.846 24.6003C12.329 25.6434 11.164 27.122 10.5047 28.8409Z" fill="#77808C"/>
                  </g>
                </svg>
                </>
                  : <>
                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="1.5" y="1.5" width="35" height="35" rx="17.5" fill="white" stroke="#F0AB83" strokeWidth="3" />
                  <path d="M25.6667 13.1667H15.6667V16.5H14V11.5H27.3333V26.5H14V21.5H15.6667V24.8333H25.6667V13.1667Z" fill="#77808C" />
                  <path d="M19.8951 23.125L18.7167 21.9467L20.8301 19.8333H10.6667V18.1667H20.8301L18.7167 16.0542L19.8951 14.875L24.0201 19L19.8951 23.125Z" fill="#BBC0C5" />
                </svg>
                  </> }
                
                <span>{ token ? 'Dashboard' : 'Login' }</span>
              </button>

              {/* Free Trial Button */}
              <button onClick={logOut} className="bg-[#6ABA9B] text-white hover:bg-[#3baa80] transition-colors duration-300 rounded-full ps-1 pe-6 py-1 flex items-center space-x-2">
              { token ? <>
                  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="38" height="38" rx="19" fill="#94D8BE"/>
                  <path d="M23.56 12.44L22.11 13.89C22.9912 14.4206 23.7203 15.1698 24.2266 16.0652C24.733 16.9605 24.9994 17.9714 25 19C25 20.5913 24.3679 22.1174 23.2426 23.2426C22.1174 24.3679 20.5913 25 19 25C17.4087 25 15.8826 24.3679 14.7574 23.2426C13.6321 22.1174 13 20.5913 13 19C13 16.83 14.16 14.94 15.88 13.88L14.44 12.44C13.3779 13.1728 12.5098 14.1528 11.9106 15.2955C11.3113 16.4383 10.9988 17.7096 11 19C11 21.1217 11.8429 23.1566 13.3431 24.6569C14.8434 26.1571 16.8783 27 19 27C21.1217 27 23.1566 26.1571 24.6569 24.6569C26.1571 23.1566 27 21.1217 27 19C27 16.28 25.64 13.88 23.56 12.44ZM20 10H18V20H20" fill="#FFF"/>
                  </svg></>
                  : <>
                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="1.5" y="1.5" width="35" height="35" rx="17.5" fill="white" stroke="#94D8BE" stroke-width="3" />
                  <path d="M16 25C18.2091 25 20 23.2091 20 21C20 18.7909 18.2091 17 16 17C13.7909 17 12 18.7909 12 21C12 23.2091 13.7909 25 16 25Z" stroke="#77808C" stroke-width="2" />
                  <path d="M19 18L22.5 14.5M22.5 14.5L24 13M22.5 14.5L25 17" stroke="#77808C" stroke-width="2" stroke-linecap="round" />
                </svg>
                  </> }
                  
                <span>{ token ? 'Logout' : 'Free Trial' }</span>
              </button>
            </div>
            </div>
            {/* <div className="grid grid-cols-2 gap-4 text-start">
              <div className="py-1">
                <h2 className='font-semibold text-[#B4BCC8] text-lg mb-8'>Our Services</h2>
                <p className='text-[#DEE4ED] font-normal text-sm'>Advanced message customization</p>
                <p className='mt-4 text-[#DEE4ED] font-normal text-sm'>Performance analytics tracking</p>
                <p className='mt-4 text-[#DEE4ED] font-normal text-sm'>Flexible phone number options</p>
                <p className='mt-4 text-[#DEE4ED] font-normal text-sm'>Multilingual messaging support</p>
                <p className='mt-4 text-[#DEE4ED] font-normal text-sm'>Scheduled broadcast delivery</p>
              </div>
              <div className="py-1">
                <h2 className='font-semibold text-[#B4BCC8] text-lg mb-8'>Pricing</h2>
                <p className='mt-8 text-[#B4BCC8] font-semibold text-lg'>Buy Credits</p>
                <p className='mt-8 text-[#B4BCC8] font-semibold text-lg'>Testimonials</p>
                <p className='mt-8 text-[#B4BCC8] font-semibold text-lg'>FAQ</p>
                <p className='mt-8 text-[#B4BCC8] font-semibold text-lg'>Contact Us</p>
              </div>
            </div> */}
            {/* <div className="my-8">
              <h2 className='text-center text-[#B4BCC8] mb-6 font-semibold text-lg'>Follow us</h2>
              <div className="justify-between flex flex-wrap">
                {socialLinks.map((link, index) => (
                  <a
                    key={index}
                    className="mb-3 text-white mx-auto flex items-center align-middle"
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon
                      className="text-[#DEA686] me-[14px] text-lg"
                      icon={link.iconClass}
                    />
                    <span className="font-normal text-sm">{link.label}</span>
                  </a>
                ))}
              </div>
            </div> */}
          </div>

          {/* Center: Links */}
          <div className='max-sm:hidden flex flex-wrap justify-center md:justify-center space-x-4 mb-2 md:mb-0 max-md:py-4'>
            {links && links.map((link, index) => ( // Changed variable name from links to link
                <a
                    key={link.id || index}
                    className='text-sm text-white max-md:mx-4 font-normal mx-2 hover:opacity-70 pt-3'
                    target={`${link.redirect_to ? '_blank' : ''}`}
                    href={`${link.redirect_to ? link.redirect_to : link.slug}`}
                >
                    {link.title}
                </a>
            ))}
          </div>

          {/* Right: Copyright */}
          <div className='max-sm:hidden text-center md:text-right text-sm'>
            &copy; Copyright 2024, All rights reserved
          </div>
        </div>
      </div>
      <div className="hidden max-sm:block max-sm:bg-[#1C212A] max-sm:py-4">
        <div className='flex mb-3'>
        {links && links.map((link, index) => ( // Changed variable name from links to link
                <a
                    key={link.id || index}
                    className='mx-auto text-[13px] font-light text-white hover:opacity-75'
                    target={`${link.redirect_to ? '_blank' : ''}`}
                    href={`${link.redirect_to ? link.redirect_to : link.slug}`}
                >
                    {link.title}
                </a>
            ))}
        </div>
        <p className="text-center text-white font-light text-[13px]">&copy; Copyright 2024, All rights reserved</p>
      </div>
    </>
  );
}

export default Footer;
